import React, { useEffect, useState } from 'react'

import {
  AlignItems,
  Icon,
  BorderStyle,
  Box,
  Color,
  Display,
  FontFamily,
  IconVariant,
  Space,
  Text,
} from '@gousto-internal/citrus-react'
import { useDispatch, useSelector } from 'react-redux'

import { noLongerCuratedBox } from 'routes/Menu/actions/menuRecipeDetails'
import { getCuratedBoxCollectionId } from 'routes/Menu/selectors/menu'

export const CuratedBoxChooseRecipeReminder = () => {
  const isCuratedBoxOrder = useSelector(getCuratedBoxCollectionId)
  const dispatch = useDispatch()
  const [isCuratedBox, setIsCuratedBox] = useState(null)

  useEffect(() => {
    if (isCuratedBoxOrder) {
      setIsCuratedBox(isCuratedBoxOrder)
      dispatch(noLongerCuratedBox())
    }
    // this is intentional as we do not want to rerender component when isCuratedBoxOrder updates
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, noLongerCuratedBox])

  return isCuratedBox ? (
    <>
      <Box
        display={Display.Flex}
        bg={Color.Informative_50}
        borderColor={Color.Informative_200}
        width="fit-content"
        paddingV={3}
        paddingH={3}
        borderStyle={BorderStyle.Solid}
        borderWidth={0.5}
        borderRadius={1.5}
        data-testid="curatedBoxChooseRecipeReminder"
      >
        <Box display={Display.Flex} alignItems={AlignItems.Center}>
          <Icon name="info" size={5} variant={IconVariant.Informative} />
          <Space direction="horizontal" size={2} />
          <Text size={1} fontFamily={FontFamily.Bold}>
            {`You'll need to choose your own recipes next time`}
          </Text>
        </Box>
      </Box>
      <Space size={2} />
    </>
  ) : null
}
